var useState_display_target;

import create_external_state from 'state_mini';

import {
  get_book_instance
} from './book.coffee';

import {
  set_theme
} from './theme.coffee';

// render 到 dom
export var render = function(dom) {
  var book, width;
  ({width} = dom.getBoundingClientRect());
  book = get_book_instance();
  book.renderTo(dom, {
    width,
    flow: 'scrolled-doc',
    allowScriptedContent: true // 这个放在设置里，让用户开启好一点
  });
  book.rendition.on('displayed', function(section) {
    // section: http://epubjs.org/documentation/0.3/#section
    // console.debug 'displayed', section.href
    return useState_display_target.set2(section.href);
  });
  return display();
};

// 当前章节
useState_display_target = create_external_state();

export var useValue_display_target = function() {
  return useState_display_target().value;
};

export var display = async function(target) {
  await get_book_instance().rendition.display(target);
  return set_theme();
};
